import { render, staticRenderFns } from "./StatusValidacao.vue?vue&type=template&id=04c362af&scoped=true"
import script from "./StatusValidacao.vue?vue&type=script&lang=js"
export * from "./StatusValidacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c362af",
  null
  
)

export default component.exports